import * as _ from 'lodash';
import { Formatter } from 'slickgrid';

export interface TextFormatterOptions {
  format: string;
}

export function text<T>(opts: TextFormatterOptions): Formatter<T> {
  const textFormat = (_ as any)[opts.format] as unknown as CallableFunction;

  if (!textFormat) {
    throw new TypeError(`Unknown textFormat: "${opts.format}"`);
  }

  return function textFormatter(row, cell, value, columnDef, data) {
    return textFormat(value);
  };
}
